export function useApp() {
  const isClient = computed(() => !import.meta.env.SSR)

  return {
    isClient,
  }
}
